module.exports = __webpack_public_path__ + "img/9.04add272.jpg";